import { render } from "./OuterPasswordEditPage.vue?vue&type=template&id=bbe24778&scoped=true&ts=true"
import script from "./OuterPasswordEditPage.vue?vue&type=script&lang=ts"
export * from "./OuterPasswordEditPage.vue?vue&type=script&lang=ts"

import "./OuterPasswordEditPage.vue?vue&type=style&index=0&id=bbe24778&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbe24778"]])

export default __exports__